module.exports = __webpack_public_path__ + "img/checkin_priority.a20e6f2b.png";